const sortFilterTypes = {
    LOW_TO_HIGH: "LOW TO HIGH",
    HIGH_TO_LOW: "HIGH TO LOW",
};

export default sortFilterTypes;